<h3 mat-dialog-title>{{description}}</h3>
<div mat-dialog-content>
<h2 style="white-space:pre">{{message}}</h2>
</div>